import { route } from '@md/routing';
import { receivedCargoesApi } from '@md/delivery/api';
import { accessPermission } from '@md/users/permissions';
import {
  DELIVERY_RECEIVED_CARGO_VIEW_LIST,
  DELIVERY_RECEIVED_CARGO_EDIT,
  DELIVERY_RECEIVED_CARGO_CREATE,
} from '@md/delivery/accessTokens';
import { receiveRoute } from '@sections/cabinet/components/views/utils';

const List = () => import('./views/List');
const Edit = () => import('./views/Edit');
const Create = () => import('./views/Create');

const RECEIVED_CARGOES_PREFIX = 'cabinet:delivery:received-cargoes:';
const p = name => RECEIVED_CARGOES_PREFIX + name;
export const LIST = p('list');
export const EDIT = p('edit');
export const CREATE = p('create');

export function createRoutes(options) {
  return [
    route('list/', List, LIST, {
      meta: accessPermission(DELIVERY_RECEIVED_CARGO_VIEW_LIST, options),
    }),
    receiveRoute(receivedCargoesApi.retrieve, [
      route('edit/', Edit, EDIT, {
        meta: accessPermission(DELIVERY_RECEIVED_CARGO_EDIT, options),
      }),
      { path: '', redirect: { name: EDIT } },
    ]),
    route('create/', Create, CREATE, {
      meta: accessPermission(DELIVERY_RECEIVED_CARGO_CREATE, options),
    }),

    { path: '', redirect: { name: LIST } },
  ];
}
